module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/icono_audio_libro.3fd6d7c0.png";